import { render, staticRenderFns } from "./profile_info.vue?vue&type=template&id=048ac9d9&scoped=true&"
import script from "./profile_info.vue?vue&type=script&lang=js&"
export * from "./profile_info.vue?vue&type=script&lang=js&"
import style0 from "./profile_info.vue?vue&type=style&index=0&id=048ac9d9&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "048ac9d9",
  null
  
)

export default component.exports